import { ModelBase } from 'store/model-base';

export class CmsDataSaver extends ModelBase {
    public static storeName: string = 'cmsDataSaver';

    public title: string;
    public start: CmsDataSaverContent;
    public inProgress: CmsDataSaverContent;
    public result: CmsDataSaverResult;
}
